/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './booking-type.reducer';

export const BookingTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bookingTypeEntity = useAppSelector(state => state.bookingType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bookingTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bookingType.detail.title">BookingType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bookingType.id">Id</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.bookingType.description">Description</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bookingType.active">Active</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.active}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.bookingType.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bookingType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.bookingType.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bookingType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bookingTypeEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/booking-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/booking-type/${bookingTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BookingTypeDetail;
